import { createContext } from 'react';

const UserContext = createContext();
const FleetContext = createContext();

export { UserContext, FleetContext };
